import type { SkillAssetCatalogEntryV1, SkillAssetRoleV1, SkillVisualProfileV1 } from './skill-asset-specs-v1.js';

/**
 * Non-product placeholder art and profile for checking the skill asset
 * runtime in a browser. Only the explicit `?skillAssets=diagnostic` mode
 * resolves profiles to this fixture; an unknown profile never falls back to
 * it. Replaced by real profiles and art when generated skills get bindings.
 */
const ROLES: readonly SkillAssetRoleV1[] = ['BODY', 'AREA', 'IMPACT', 'TRAIL', 'CAST'];

export const DIAGNOSTIC_SKILL_ASSET_CATALOG_V1: readonly SkillAssetCatalogEntryV1[] = Object.freeze(ROLES.map((role) =>
  Object.freeze({ assetKey: `diagnostic.${role.toLowerCase()}`, role, file: `diagnostic/${role.toLowerCase()}.png` })));

export const DIAGNOSTIC_SKILL_VISUAL_PROFILE_V1: SkillVisualProfileV1 = Object.freeze<SkillVisualProfileV1>({
  profileId: 'diagnostic',
  cast: { role: 'CAST', assetKey: 'diagnostic.cast' },
  stages: {
    primary: {
      BODY: { role: 'BODY', assetKey: 'diagnostic.body' },
      AREA: { role: 'AREA', assetKey: 'diagnostic.area' },
      IMPACT: { role: 'IMPACT', assetKey: 'diagnostic.impact' },
      TRAIL: { role: 'TRAIL', assetKey: 'diagnostic.trail' },
    },
  },
});
